var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPldBlog(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 11.5a.75.75 0 100 1.5h6.5a.75.75 0 100-1.5h-6.5zm0 2.75a.75.75 0 100 1.5h6.5a.75.75 0 100-1.5h-6.5zm0 2.75a.75.75 0 100 1.5h6.5a.75.75 0 100-1.5h-6.5zm4.835-14.414l5.829 5.828A2 2 0 0120 9.828V20a2 2 0 01-2 2H6a2 2 0 01-2-2V4a2 2 0 012-2h6.172a.66.66 0 01.082.007c.02.003.04.006.059.007.215.015.427.056.624.138.057.024.112.056.166.087l.05.029.047.024a.992.992 0 01.081.044c.078.053.148.116.219.18l.036.03.049.04zM18 20.5a.5.5 0 00.5-.5V10H14a2 2 0 01-2-2V3.5H6a.5.5 0 00-.5.5v16a.5.5 0 00.5.5h12zm-.622-12L13.5 4.621V8a.5.5 0 00.5.5h3.378z",
    fill: "#333230"
  })));
}
export default SvgPldBlog;